import React from 'react'
import { ArrowRight } from 'lucide-react'
import { usePopup } from '../context/PopupContext'

const Hero: React.FC = () => {
  const { openPopup } = usePopup();
  return (
    <div className="relative h-screen w-full flex items-center justify-center overflow-hidden" id="home">
      {/* Background Media */}
      <div className="absolute inset-0 z-0">
        {/* Mobile: Static Image */}
        <div className="absolute inset-0 md:hidden">
          <img
            src="/working/3.JPG"
            alt="Luxury Real Estate"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Tablet/Desktop: Video */}
        <div className="hidden md:block absolute inset-0">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-fill"
          >
            <source src="/herovideo/webssb.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="absolute inset-0 bg-black/60 md:bg-black/50" /> {/* Slightly darker overlay on mobile for text readability */}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto animate-fade-in">
        <h2 className="text-primary-400 font-bold tracking-widest uppercase mb-4 text-xs md:text-base">
          Known for giving Best Prices across all project
        </h2>
        <h1 className="text-3xl sm:text-5xl md:text-7xl font-bold text-white mb-6 leading-tight font-bricolage">
          Research Based <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-300 to-primary-500">
            Real Estate Investments
          </span>
        </h1>
        <p className="text-gray-200 text-base md:text-2xl mb-8 md:mb-10 max-w-3xl mx-auto font-medium">
          Gurgaon • Delhi • Uttarakhand
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#projects"
            className="px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all transform hover:scale-105 flex items-center gap-2"
          >
            Invest Now
            <ArrowRight className="w-5 h-5" />
          </a>
          <button
            onClick={() => openPopup('General Inquiry')}
            className="px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white border border-white/30 font-semibold rounded-full transition-all"
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Scroll Down Indicator */}

    </div >
  )
}

export default Hero
